import React from 'react';

const Divider = ({weak}) => (
    <div className={`divider ${weak && 'weak'}`} />
);

export default Divider;
